module.exports = __webpack_public_path__ + "static/media/fs2.fb788632.pdf";